import { createApp } from 'vue';
import mixins from './../../shared/js/helpers/mixins'
import DepartmentsMap from './components/DepartmentsMap.vue';
import I18NextVue from 'i18next-vue';
import VueGoogleMaps from 'vue-google-maps-community-fork';

window.app = createApp(DepartmentsMap, {
    departmentIds: window.departmentIds,
    departments: window.departments,
    zoom: window.zoom,
    latitude: window.latitude,
    longitude: window.longitude,
  })
  .use(VueGoogleMaps, {
    load: {
      key: mapsApiKey,
    },
    autobindAllEvents: true,
  })
  .use(I18NextVue, { i18next }).mixin(mixins)
  .mount('#departments-map');
